import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { FEATURE_FLAGS } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../../route';
import { PriceListBreakPivotPage } from './PriceListBreakPivotPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/item-master/utilities/price-list-break-pivot',
  staticData: {
    app: {
      access: {
        featureFlag: FEATURE_FLAGS['item-master-ui-enabled'],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Product }],
      },
    },
  },
  component: PriceListBreakPivotPage,
  loader: () => ({
    crumb: msg('Price List Break Pivot', { context: 'page breadcrumb' }),
  }),
});
